<template>
    <div>
      <div class="qr-code-header">
        {{$vuetify.lang.t('$vuetify.checkinQr.textHeader')}}
      </div>

      <div class="qr-code-body">
        <qrcode-render
          @detect="detectCode"/>
      </div>

      <info-modal
            ref="infoModal"
            @ok-submit="closeWindow"
            :msg="infoMsg"/>

      <liff-error-modal
            ref="errorModal"
            @ok-submit="closeWindow"
            :msg="errorMsg"/>
    </div>
</template>

<script>
import QrcodeRender from '@/components/liff/QrcodeRender'
import InfoModal from '@/components/modal/InfoModal'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import axios from 'axios'
const LIMIT_TIME_SCAN = 15
export default {
    name: 'CheckInQR',

    components: {
        QrcodeRender,
        LiffErrorModal,
        InfoModal
    },

    data () {
        return {
            lineId: null,
            infoMsg: null
        }
    },

    methods: {
        async detectCode (dataStr) {
            const data = JSON.parse(dataStr)
            const timestamp = this.calculateTime(data.timestamp, new Date().getTime())
            if (timestamp <= LIMIT_TIME_SCAN) {
                await this.receiveAlarm(data)
            } else {
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkinQr.msgError'))
            }
        },

        calculateTime (qrTimestamp, currentTimestamp) {
            return (currentTimestamp - qrTimestamp) * 0.001 // convert time ms to s
        },

        async receiveAlarm (data) {
            this.$store.dispatch('setLoading', true)
            const formData = {
                lineId: this.lineId,
                time: `${data.date} ${data.time}`,
                serialNumber: data.serialNumber,
                attendanceType: null,
                eventType: 'QR_SCAN'
            }

            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/receive-alarm/sunmi/callback`, formData)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.infoMsg = this.$vuetify.lang.t('$vuetify.checkinQr.msgSuccess')
                this.$refs.infoModal.dialog = true
            } else {
                this.$store.dispatch('setLoading', false)
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkinQr.msgError'))
            }
            this.$store.dispatch('setLoading', false)
        },

        errorModal (message) {
            this.$store.dispatch('setLoading', false)
            this.$refs.errorModal.dialog = true
            this.errorMsg = message
        },

        closeWindow () {
            this.$liff.closeWindow()
        },

        async getLineLangByRichMenu () {
            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/line/employee-profile`, { lineId: this.lineId })
            if (res && res.data && res.data.status === 'ok') {
                this.$vuetify.lang.current = res.data.data.lineLang
            }
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.lineId = await this.$util.getLineIdForLiff(process.env.VUE_APP_LINE_CHECK_IN_QR_LIFF)
            await this.getLineLangByRichMenu()
        } catch (error) {
            this.errorAlert(this.$vuetify.lang.t('$vuetify.approvalInquiry.cannotGetLineId'))
        }
        this.$store.dispatch('setLoading', false)
    }
}
</script>

<style lang="scss" scoped>
  .qr-code-header {
    display: flex;
    justify-content: center;
    align-items: end;
    padding-bottom: 1rem;
    height: 10vh;
  }

  .qr-code-body {
    height: 80vh;
  }
</style>
